import React, { useEffect } from 'react';
import { LoadingScreen } from '../../components/LoadingScreen';
import { useSetRecoilState, useRecoilState } from 'recoil';
import { tokensState, referrerState } from '../../features/auth';
import { Redirect, useLocation } from 'react-router-dom';

export function SignOut() {
	const [tokens, setTokens] = useRecoilState(tokensState);
	const { hash, search, state } = useLocation();

	const setReferrer = useSetRecoilState(referrerState);

	useEffect(() => {
		if (tokens) {
			setReferrer({
				hash,
				pathname: '/authorize',
				search,
				state,
			});
			setTokens(null);
			localStorage.removeItem('tokens');
			sessionStorage.removeItem('tokens');
		}
	}, [tokens, hash, search, state, setReferrer, setTokens]);

	return tokens ? <LoadingScreen /> : <Redirect to="/sign_in" />;
}
